import ServicePage from "../Common/ServicePage";

// Leak Fix specific services
const leakFixServices = [
  { 
    id: 1, 
    name: 'Minor Leak Repair', 
    provider: 'QuickLeak Experts', 
    image: 'https://placehold.co/600x400?text=Minor+Leak+Repair', 
    rating: 4.8, 
    reviews: 500, 
    price: 250, 
    category: 'Minor Repair' 
  },
  { 
    id: 2, 
    name: 'Major Leak Repair', 
    provider: 'ProLeak Professionals', 
    image: 'https://placehold.co/600x400?text=Major+Leak+Repair', 
    rating: 4.85, 
    reviews: 350, 
    price: 600, 
    category: 'Major Repair' 
  },
  { 
    id: 3, 
    name: 'Pipe Joint Sealing Service', 
    provider: 'SealMasters Solutions', 
    image: 'https://placehold.co/600x400?text=Pipe+Joint+Sealing', 
    rating: 4.82, 
    reviews: 280, 
    price: 150, 
    category: 'Pipe Sealing' 
  },
  { 
    id: 4, 
    name: 'Water Flow Check Service', 
    provider: 'FlowCheck Specialists', 
    image: 'https://placehold.co/600x400?text=Water+Flow+Check', 
    rating: 4.78, 
    reviews: 320, 
    price: 100, 
    category: 'Flow Inspection' 
  },
  { 
    id: 5, 
    name: 'Tap Leak Repair', 
    provider: 'TapFix Experts', 
    image: 'https://placehold.co/600x400?text=Tap+Leak+Repair', 
    rating: 4.83, 
    reviews: 450, 
    price: 180, 
    category: 'Tap Repair' 
  },
  { 
    id: 6, 
    name: 'Pipe Burst Repair', 
    provider: 'BurstPipe Professionals', 
    image: 'https://placehold.co/600x400?text=Pipe+Burst+Repair', 
    rating: 4.86, 
    reviews: 200, 
    price: 800, 
    category: 'Emergency Repair' 
  },
  { 
    id: 7, 
    name: 'Water Tank Leak Repair', 
    provider: 'TankLeak Solutions', 
    image: 'https://placehold.co/600x400?text=Water+Tank+Leak', 
    rating: 4.79, 
    reviews: 150, 
    price: 400, 
    category: 'Tank Repair' 
  },
  { 
    id: 8, 
    name: 'Underground Pipe Leak Detection', 
    provider: 'UndergroundLeak Experts', 
    image: 'https://placehold.co/600x400?text=Underground+Leak', 
    rating: 4.84, 
    reviews: 120, 
    price: 350, 
    category: 'Leak Detection' 
  },
  { 
    id: 9, 
    name: 'Shower Leak Repair', 
    provider: 'ShowerLeak Professionals', 
    image: 'https://placehold.co/600x400?text=Shower+Leak+Repair', 
    rating: 4.81, 
    reviews: 380, 
    price: 220, 
    category: 'Shower Repair' 
  },
  { 
    id: 10, 
    name: 'Toilet Leak Repair', 
    provider: 'ToiletLeak Solutions', 
    image: 'https://placehold.co/600x400?text=Toilet+Leak+Repair', 
    rating: 4.77, 
    reviews: 290, 
    price: 300, 
    category: 'Toilet Repair' 
  },
  { 
    id: 11, 
    name: 'Pressure Valve Leak Repair', 
    provider: 'ValveFix Experts', 
    image: 'https://placehold.co/600x400?text=Pressure+Valve+Repair', 
    rating: 4.85, 
    reviews: 180, 
    price: 280, 
    category: 'Valve Repair' 
  },
  { 
    id: 12, 
    name: 'Emergency Leak Service', 
    provider: 'EmergencyLeak Services', 
    image: 'https://placehold.co/600x400?text=Emergency+Leak', 
    rating: 4.89, 
    reviews: 250, 
    price: 700, 
    category: 'Emergency Service' 
  },
  { 
    id: 13, 
    name: 'Water Heater Leak Repair', 
    provider: 'HeaterLeak Professionals', 
    image: 'https://placehold.co/600x400?text=Water+Heater+Leak', 
    rating: 4.82, 
    reviews: 210, 
    price: 450, 
    category: 'Heater Repair' 
  },
  { 
    id: 14, 
    name: 'Pipe Corrosion Leak Repair', 
    provider: 'CorrosionFix Experts', 
    image: 'https://placehold.co/600x400?text=Corrosion+Repair', 
    rating: 4.76, 
    reviews: 170, 
    price: 350, 
    category: 'Corrosion Repair' 
  }
];

const leakFixCategories = ['Minor Repair', 'Major Repair', 'Pipe Sealing', 'Flow Inspection', 'Tap Repair', 'Emergency Repair', 'Tank Repair', 'Leak Detection', 'Shower Repair', 'Toilet Repair', 'Valve Repair', 'Emergency Service', 'Heater Repair', 'Corrosion Repair'];

const packages = [
  { id: 1, title: "Minor Leak Repair", rating: "4.8 (500 reviews)", price: 250, originalPrice: 300, icon: "💧" },
  { id: 2, title: "Major Leak Repair", rating: "4.85 (350 reviews)", price: 600, originalPrice: 700, icon: "🚰" },
];

const miniServices = [
  { id: 101, title: "Pipe Joint Sealing", price: 150, icon: "🔧" },
  { id: 102, title: "Water Flow Check", price: 100, icon: "📊" },
];

export default function LeakFix() {
  return (
    <ServicePage
      serviceName="Leak Fix"
      packages={packages}
      miniServices={miniServices}
      customServices={leakFixServices}
      customCategories={leakFixCategories}
      isCustomService={true}
    />
  );
}